//LIBRARIES
import { useTranslation } from "react-i18next";

// ASSETS
import InactivePaymentIcon from "assets/Icons/ReportsTabsIcons/InactivePaymentsIcon.svg";
import InactiveRentIcon from "assets/Icons/ReportsTabsIcons/InactiveRentIcon.svg";
import InactiveUsersIcon from "assets/Icons/ReportsTabsIcons/InactiveUsersIcon.svg";
import ActivePaymentIcon from "assets/Icons/ReportsTabsIcons/ActivePaymentsIcon.svg";
import ActiveRentIcon from "assets/Icons/ReportsTabsIcons/ActiveRentIcon.svg";
import ActiveUsersIcon from "assets/Icons/ReportsTabsIcons/ActiveUsersIcon.svg";

// CONSTANTS USING LIBRARIES

export const TabsData = () => {
  const { t } = useTranslation();

  return {
    reportsTabsEntries: [
      {
        title: t("page.reports.reportsTabs.rents"),
        path: "rentals",
        icons: {
          active: ActiveRentIcon,
          inactive: InactiveRentIcon,
        },
      },
      {
        title: t("page.reports.reportsTabs.users"),
        path: "users",
        icons: {
          active: ActiveUsersIcon,
          inactive: InactiveUsersIcon,
        },
      },
    ],
    auditTabsEntries: [
      {
        title: t("page.reports.auditTabs.rents"),
        path: "rentals_logs",
        icons: {
          active: ActiveRentIcon,
          inactive: InactiveRentIcon,
        },
      },
      {
        title: t("page.reports.auditTabs.sms"),
        path: "sms_logs",
        icons: {
          active: ActiveUsersIcon,
          inactive: InactiveUsersIcon,
        },
      },
    ],
    invoicesTabsEntries: [
      {
        title: t("page.reports.reportsTabs.payments"),
        path: "payments",
        icons: {
          active: ActivePaymentIcon,
          inactive: InactivePaymentIcon,
        },
      },
      {
        title: t("page.reports.auditTabs.invoices"),
        path: "invoices_logs",
        icons: {
          active: ActiveUsersIcon,
          inactive: InactiveUsersIcon,
        },
      },
    ],
  };
};

export interface IProps {}
